import { useDiaryByIdQuery } from "@/features/diaries/api";
import { usePatientsCopy } from "@/features/i18n/patientsCopy";
import { useFormatClinicianActionLabel } from "@/features/i18n/clinicianActionLabel";
import { interfaceComponents as ic } from "@/features/patients/features/interface/components";
import { useProfileQuery } from "@/features/profile/api/selectProfile";
import { hooks as h } from "@/hooks";
import type { ActionDefinitionT } from "@patient-watch/types";
import type { StatefulDiaryT } from "@patient-watch/types";
import type { ExtendedProfileT } from "@patient-watch/types";
import { createFileRoute } from "@tanstack/react-router";

const Action = () => {
    const copy = usePatientsCopy();
    const formatActionLabel = useFormatClinicianActionLabel();
    const { diaryId, actionId } = Route.useParams();
    const { data: profile } = useProfileQuery();
    const { data: diary } = useDiaryByIdQuery(diaryId);
    const { action } = Route.useSearch();

    h.useNav([
        { label: copy.patients, route: { to: "/patients" } },
        {
            label: diary?.patient_info?.patient_name ?? copy.patientFallback,
            route: { to: "/patients/$diaryId", params: { diaryId: diaryId } },
        },
        {
            label: action ? formatActionLabel(action.action_key, action.action_name) : copy.action,
            route: {
                to: "/patients/$diaryId/action/$actionId",
                params: { diaryId: diaryId, actionId: actionId },
            },
        },
    ]);

    if (!diary || !profile) {
        return (
            <div className="p-8 text-muted-foreground text-center">
                {!diary ? copy.diaryCouldNotLoad : copy.profileCouldNotLoad}
            </div>
        );
    }

    return (
        <ic.ActionEmail
            profile={profile as ExtendedProfileT}
            diary={diary as StatefulDiaryT}
            action={action}
            actionId={actionId}
        />
    );
};

type ActionSchema = {
    action: ActionDefinitionT;
};

export const Route = createFileRoute("/_app/patients/$diaryId/action/$actionId")({
    validateSearch: (search: Record<string, unknown>): ActionSchema => {
        return {
            action: search.action as ActionDefinitionT,
        };
    },
    component: Action,
});
